import { z } from 'zod';
export const KeycloakConfigSchema = z.object({
    applicationID: z.string(),
    callbackURL: z.string(),
    keycloakURL: z.string(),
    loggedOutURL: z.string(),
    logoutURL: z.string(),
    tenantID: z.string(),
    tokenRevocationURL: z.string(),
    type: z.literal('keycloak'),
    userInfoURL: z.string(),
});
export const OAuth2ConfigSchema = KeycloakConfigSchema;
//# sourceMappingURL=OAuthConfigSchema.js.map